import { useForm } from "react-hook-form";
import { defaultFormValues } from "../../consts/form";
import { useProduct } from "../../hooks/useProduct";
import { useRoute } from "../../hooks/useRoute";
import { FormValues } from "../../types/form";
import { CustomOrderProps } from "./CustomOrder";

export function useCustomOrder(): CustomOrderProps {
  const { path, setPath } = useRoute();
  const form = useForm<FormValues>({
    mode: "onChange",
    defaultValues: defaultFormValues,
  });
  const { control, getValues } = form;

  const { product } = useProduct();

  return {
    path,
    setPath,
    control,
    getValues,
    product,
  };
}
